export default "__VITE_ASSET__CDAI2Sg2__"